module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/modal-profile-5-image-c87bec2246b92d7aafdc0511d07f5d97.png";